var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.1904C5.91073 2.1904 2.1904 5.91073 2.1904 10.5C2.1904 15.0892 5.91073 18.8096 10.5 18.8096C15.0892 18.8096 18.8096 15.0892 18.8096 10.5C18.8096 5.91073 15.0892 2.1904 10.5 2.1904ZM1.30957 10.5C1.30957 5.42426 5.42426 1.30957 10.5 1.30957C15.5757 1.30957 19.6904 5.42426 19.6904 10.5C19.6904 15.5757 15.5757 19.6904 10.5 19.6904C5.42426 19.6904 1.30957 15.5757 1.30957 10.5Z",
    fill: "#3B3E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L10 10.5L7 7",
    stroke: "#3B3E43",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14L15 10.5L12 7",
    stroke: "#3B3E43",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question.a1600f035ca296c532120c586aa041ff.svg";